//TODO: struttura non definitiva, modificare appena si ha la struttura ufficiale

export interface ZoneItem {
    id: string,
    codice: string,
    nome: string,
    proprietario?: string,
    zonaNoProvvigioni: string,
    business: string,
    area?: string,
    regione?: string,
    ufficioVendita?: string,
    businessLine?: string,
    toBeExported: string,
}